import character from '../../images/character.svg';
import { IoIosArrowForward } from 'react-icons/io';
import { useNavigate } from "react-router-dom";

export default function CardCompany({ sttstcInfo }: any) {
  const navigate = useNavigate();
  const totWorkHandler = () => {
    navigate('/total-work');
  };
  const smartTBMHandler = () => {
    navigate('/tbm-current-status')
  };
  const teamTBMHandler = () => {
    navigate('/tm-tbm-current-status');
  };
  const nonconformityHandler = () => {
    navigate('/nonconformity');
  };
  const suggestHandler = () => {
    navigate('/sgst');
  };
  const stopHandler = () => { navigate('/stop-request', { state: { isRequest: false } }); };

  return (
    <div className='bg-white text- w-full rounded-[8px] md:rounded-[20px] flex flex-col items-center mt-[0.563rem] md:mt-[1.47rem] relative'>
      <img className='absolute w-[3.7rem] top-[-19%] right-[2%] md:w-[9.25rem]' src={character} alt='character' />
      <p className='text-txtBlack font-semibold text-[1rem] mt-[1.06rem] w-[84.7%] md:text-40 md:mt-[2.65rem]'>오늘의 현황</p>
      {/* <div className='w-[1.68rem] h-[1.68rem] bg-[#FFEEEF] rounded-full absolute top-[24%] left-[5%] z-0' /> */}
      <table className='table-fixed text-txtBlack mt-[0.938rem] md:mt-[2.345rem] w-[90%] z-10'>
        <tbody>
          <tr className='hover:cursor-pointer'>
            <td onClick={totWorkHandler} className='w-[45%] text-[0.9rem] md:text-[2.25rem] leading-25 md:leading-[62px] whitespace-pre-line text-center' rowSpan={2}>
              일반작업{'\n'}/위험작업{'\n'}<span className='text-[0.95rem] sm:text-[1.2rem] md:text-[3rem] text-point font-preBold mr-[0.125rem] md:mr-[0.312rem]'>{sttstcInfo.totWrkInfo?.totWrkCnt - sttstcInfo.totWrkInfo?.dngrWrkCnt}/{sttstcInfo.totWrkInfo?.dngrWrkCnt}</span>건</td>
            <td onClick={smartTBMHandler} className='w-[25%] text-[0.75rem] sm:text-[0.875rem] md:text-[2.18rem]  border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.938rem] md:pb-[2.345rem]'>개인 TBM</td>
            <td onClick={smartTBMHandler} className='w-[25%] text-[0.85rem] sm:text-[0.938rem] md:text-[2.345rem] text-right text-point font-preBold border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.938rem] md:pb-[2.345rem]'>{sttstcInfo.smrtTbmStatInfo?.wrkrMngrStat}</td>
            <td onClick={smartTBMHandler} className='text-[0.813rem] md:text-[2.03rem] pb-15 md:pb-[37px]'><IoIosArrowForward /></td>
          </tr>
          <tr onClick={teamTBMHandler} className='hover:cursor-pointer'>
            <td className='text-[0.75rem] sm:text-[0.875rem] md:text-[2.18rem] pt-[0.938rem] md:pt-[2.345rem]' >팀 TBM</td>
            <td className='text-[0.75rem] sm:text-[0.875rem] md:text-[2.18rem] pt-[0.938rem] md:pt-[2.345rem] text-right text-point font-preBold'>{sttstcInfo.tmTbmInfo?.cmpltCnt}/{sttstcInfo.tmTbmInfo?.totCnt}({sttstcInfo.tmTbmInfo?.cmpltRate === 0 ? 0 : sttstcInfo.tmTbmInfo?.cmpltRate < 10 ? sttstcInfo.tmTbmInfo?.cmpltRate : sttstcInfo.tmTbmInfo?.cmpltRate >= 10 ? sttstcInfo.tmTbmInfo?.cmpltRate : null}%)</td>
            <td className='text-[0.813rem] md:text-[2.03rem] pt-[0.938rem] md:pt-[2.345rem]'><IoIosArrowForward /></td>
          </tr>
        </tbody>
      </table>
      <div className='w-[90%] h-[4.5rem] sm:h-[5.4rem] md:h-[13.5rem] bg-[#FFEEEF] bg-opacity-[54%] rounded-[8px] md:rounded-[20px] my-[0.625rem] md: my-[1.562rem] flex flex-col justify-center relative pr-[0.4rem] md:pr-[1rem]'>
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] left-[33%]' />
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] right-[36%]' />
        <table className='text-mainTxtPoint text-[1.56rem] md:text-[3.9rem] font-preBold w-full table-fixed text-center'>
          <tbody>
            <tr className='hover:cursor-pointer'>
              <td onClick={nonconformityHandler}>{sttstcInfo.sftyChkDataCnt}</td>
              <td onClick={suggestHandler}>{sttstcInfo.sgstDataCnt}</td>
              <td onClick={stopHandler}>{sttstcInfo.wrkStopDataCnt}</td>
            </tr>
            <tr className='hover:cursor-pointer text-[0.8rem] sm:text-[0.875rem] md:text-[2.18rem] text-txtBlack'>
              <td onClick={nonconformityHandler}>부적합</td>
              <td onClick={suggestHandler}>건의사항</td>
              <td onClick={stopHandler}>작업중지요청</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

